// extracted by mini-css-extract-plugin
export default {"backDiv":"Loader_backDiv__Ok2Zy","loaderImg":"Loader_loaderImg__ZG4Rw"};